import { render, staticRenderFns } from "./GroupSyncConfig.vue?vue&type=template&id=0c86ccf4&scoped=true"
import script from "./GroupSyncConfig.vue?vue&type=script&lang=ts"
export * from "./GroupSyncConfig.vue?vue&type=script&lang=ts"
import style0 from "./GroupSyncConfig.vue?vue&type=style&index=0&id=0c86ccf4&prod&lang=css"
import style1 from "./GroupSyncConfig.vue?vue&type=style&index=1&id=0c86ccf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86ccf4",
  null
  
)

export default component.exports